<script lang="ts">
  import { fa } from '../../../shared/i18n/fa';

  /** `Lot D2701`, or «بدون Lot»; the lot itself is Latin, so it keeps its own direction. */
  let { lot }: { lot: string | null } = $props();
</script>

<!-- One isolate for the whole Latin phrase, so RTL text around it never reorders «Lot» and the number. -->
{#if lot}<bdi dir="ltr">{`${fa.inventory.lot} ${lot}`}</bdi>{:else}{fa.inventory.noLot}{/if}
